import React, { Component } from 'react';
import PropTypes from 'prop-types';

class AcrValueAutocomplete extends Component {

    static propTypes = {
        value: PropTypes.string,
        options: PropTypes.arrayOf(PropTypes.string),
        placeholder: PropTypes.string,
        className: PropTypes.string,
        onChange: PropTypes.func.isRequired
    };

    state= {
        showSuggestions: false,
        highlightedIndex: -1
    }

    commitValue = (val) => {
        this.props.onChange(val);
        this.setState({ showSuggestions: false, highlightedIndex: -1 });
    };

    handleInputChange = (e) => {
        this.props.onChange(e.target.value);
        this.setState({ showSuggestions: true, highlightedIndex: -1 });
    };

    handleKeyDown = (e) => {
        const { value = '', options = [] } = this.props;
        const filtered = (value.length
            ? options.filter(o => o.toLowerCase().includes(value.toLowerCase()))
            : options).slice().sort((a, b) => b.localeCompare(a, undefined, { sensitivity: 'base' }));

        if (!filtered.length) return;

        const { showSuggestions, highlightedIndex } = this.state;

        if (e.key === 'ArrowDown') {
            e.preventDefault();
            if (!showSuggestions) {
                this.setState({ showSuggestions: true, highlightedIndex: 0 });
            } else {
                this.setState({
                    highlightedIndex: (highlightedIndex + 1) % filtered.length
                });
            }
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            if (!showSuggestions) {
                this.setState({ showSuggestions: true, highlightedIndex: filtered.length - 1 });
            } else {
                this.setState({
                    highlightedIndex: (highlightedIndex - 1 + filtered.length) % filtered.length
                });
            }
        } else if (e.key === 'Enter') {
            if (showSuggestions && highlightedIndex >= 0) {
                e.preventDefault();
                this.commitValue(filtered[highlightedIndex]);
            }
        } else if (e.key === 'Escape') {
            if (showSuggestions) {
                e.preventDefault();
                this.setState({ showSuggestions: false, highlightedIndex: -1 });
            }
        } else if (e.key === 'Tab') {
            if (showSuggestions && highlightedIndex >= 0) {
                this.commitValue(filtered[highlightedIndex]);
            }
        }
    };

    handleBlur = () => {
        this.setState({ showSuggestions: false, highlightedIndex: -1 });
    };

    render() {
        const { value, options = [], placeholder, className } = this.props;
        const { showSuggestions, highlightedIndex } = this.state;

        const filtered = ((value || '').length
            ? options.filter(o => o.toLowerCase().includes(value.toLowerCase()))
            : options).slice().sort((a, b) => b.localeCompare(a, undefined, { sensitivity: 'base' }));

        return (
            <div className="acr-input-wrapper">
                <input
                    ref={this.inputRef}
                    type="text"
                    value={value}
                    onChange={this.handleInputChange}
                    onFocus={() => this.setState({ showSuggestions: true })}
                    onBlur={this.handleBlur}
                    onKeyDown={this.handleKeyDown}
                    placeholder={placeholder}
                    className={className}
                />
                {showSuggestions && filtered.length > 0 && (
                    <ul className="acr-suggestions" role="listbox">
                        {filtered.map((opt, idx) => (
                            <li key={opt}>
                                <button
                                    type="button"
                                    role="option"
                                    aria-selected={highlightedIndex === idx}
                                    className={
                                        "acr-suggestion-btn" + (highlightedIndex === idx ? " active" : "")
                                    }
                                    onMouseDown={(e) => e.preventDefault()}
                                    onMouseEnter={() => this.setState({ highlightedIndex: idx })}
                                    onClick={() => this.commitValue(opt)}
                                >
                                    {opt}
                                </button>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        );
    }
}

export default AcrValueAutocomplete;
